import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import PropTypes from "prop-types";
import { Field, Form } from "react-final-form";
import { Button, makeStyles } from "@material-ui/core";
import FormTextField from "../../form/final-form/FormTextField";

const useStyles = makeStyles({
  buttonActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 15,
    marginTop: 15,
  },
  bold: {
    fontWeight: "bold",
  },
});

const AddClientPeselNumberDialog = ({ onSave, onCancel, open }) => {
  const classes = useStyles();
  return (
    <Dialog open={open}>
      <DialogTitle>Przypisanie numeru PESEL</DialogTitle>
      <DialogContent>
        <Form
          onSubmit={onSave}
          render={({ handleSubmit, submitting, errors, touched }) => (
            <>
              <form onSubmit={handleSubmit}>
                <div>
                  <Field
                    id="pesel"
                    name="pesel"
                    component={FormTextField}
                    label="Numer PESEL"
                    helperText={touched.pesel && errors.pesel}
                    error={touched.pesel && errors.pesel}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className={classes.buttonActions}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                  >
                    Zapisz
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onCancel}
                    disabled={submitting}
                  >
                    Anuluj
                  </Button>
                </div>
              </form>
            </>
          )}
        />
      </DialogContent>
    </Dialog>
  );
};

AddClientPeselNumberDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  dispatch: PropTypes.func,
};

export default AddClientPeselNumberDialog;
